"use strict";

var _slicedToArray = require("/codebuild/output/src213846038/src/github.com/rteamweb/web-marketing-ui/application/node_modules/@babel/runtime/helpers/slicedToArray.js");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useWindowSize = void 0;

var react_1 = require("react");

var useWindowSize = function useWindowSize() {
  var _ref = (0, react_1.useState)([0, 0]),
      _ref2 = _slicedToArray(_ref, 2),
      size = _ref2[0],
      setSize = _ref2[1];

  (0, react_1.useLayoutEffect)(function () {
    function updateSize() {
      setSize([window === null || window === void 0 ? void 0 : window.innerWidth, window === null || window === void 0 ? void 0 : window.innerHeight]);
    }

    window === null || window === void 0 ? void 0 : window.addEventListener("resize", updateSize);
    updateSize();
    return function () {
      return window === null || window === void 0 ? void 0 : window.removeEventListener("resize", updateSize);
    };
  }, []);
  return size;
};

exports.useWindowSize = useWindowSize;